import { handleActions } from 'redux-actions';
import { createSelector } from '@reduxjs/toolkit';
import { PAYMENT_LOG_PAGE_MODULE, REPORTS_PAGE_MODULE } from '../../configs/moduleNames';
import { createLoadListReducerWithBegin } from '../../utils/getCrudConfig';
import { LOAD_REPORTS_LIST } from './actions';

const initialState = {
  reportsList: [],
  loadingReportsList: false,
  reportsListMeta: {},
};

const reducer = handleActions({
  ...createLoadListReducerWithBegin(REPORTS_PAGE_MODULE + LOAD_REPORTS_LIST, 'reportsList', 'loadingReportsList'),
}, initialState);

export default reducer;

export const getReportsData = createSelector(
  [state => state[REPORTS_PAGE_MODULE]],
  state => {
    const {
      reportsList,
      loadingReportsList,
      reportsListMeta,
    } = state;

    return {
      reportsList,
      loadingReportsList,
      reportsListMeta,
    };
  },
);
